var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreasvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_639_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.72465 22.4798L8.43879 22.1572C8.11471 21.7919 0.501953 13.158 0.501953 8.73323C0.501953 4.19844 4.19063 0.509766 8.72465 0.509766C13.2587 0.509766 16.9474 4.19844 16.9474 8.73323C16.9474 13.158 9.33459 21.7919 9.01051 22.1572L8.72465 22.4798ZM8.72465 1.2741C4.61177 1.2741 1.26629 4.62035 1.26629 8.73323C1.26629 12.4112 7.32439 19.6884 8.72465 21.3203C10.1249 19.6877 16.183 12.4097 16.183 8.73323C16.1838 4.62035 12.8375 1.2741 8.72465 1.2741Z",
    fill: "#EA3E2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72486 12.3001C6.75823 12.3001 5.15771 10.6996 5.15771 8.73295C5.15771 6.76555 6.75823 5.16504 8.72486 5.16504C10.6923 5.16504 12.292 6.76555 12.292 8.73295C12.2928 10.6996 10.6923 12.3001 8.72486 12.3001ZM8.72486 5.92937C7.17938 5.92937 5.92205 7.18746 5.92205 8.73295C5.92205 10.2784 7.17938 11.5358 8.72486 11.5358C10.2703 11.5358 11.5277 10.2784 11.5277 8.73295C11.5284 7.1867 10.2711 5.92937 8.72486 5.92937Z",
    fill: "#EA3E2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_639_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4462,
    height: 21.97,
    fill: "white",
    transform: "translate(0.501953 0.509766)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreasvg);
export default __webpack_public_path__ + "static/media/area.svg.6a0f8e6a0deb5e29598bcb1718263aa0.svg";
export { ForwardRef as ReactComponent };